import {format}  from 'money-formatter'
import moment from 'moment'

export default class Formatacao{
    
    static localDate( date ){
        if(!date){
            return null;
        }
        return moment(date).format('DD/MM/YYYY')

    }

    static currency( value ){
        return value ? format('BRL', value) : null;
    }
}

